"use strict";
// This avoids the warning in the console.
require("events").EventEmitter.prototype._maxListeners = 0;

/**
 * Copyright 2014, Intelliact AG
 * Copyrights licensed under the New BSD License
 * Created by sahun@intelliact on 11.12.2014.
 *
 * Instance of the mcFly library.
 * This avoid we have to instanciate the lib every time.
 *
 */

var McFly = require("./mcFly/McFly");
var mcFly = new McFly();
module.exports = mcFly;
